import { UICommandContext } from "../../../library-js/dom-ui/commands/UICommandContext";
import { UICommand } from "../../../library-js/dom-ui/commands/UICommand";
import { UICommandManager } from "../../../library-js/dom-ui/commands/UICommandManager";
import { NodeGraph } from "../model/NodeGraph";
import { Delete } from "./Delete";
import { NGCommandManager } from "./NGCommandManager";
import { NGCommandContext } from "./NGCommandContext";

export abstract class NGCommand extends UICommand<NGCommandContext>
{
  _manager:NGCommandManager;
  constructor( ng:NGCommandManager )
  {
    super();
    this._manager = ng;

    this._manager._commands.push( this );
    this._initialize();
  }

  protected abstract _initialize():void

  get selection()
  {
    return this._manager._nodeGraph._selection;
  }
}